module.exports = __webpack_public_path__ + "img/sabatical-icon.7ac196f9.svg";